__turbopack_context__.v({
  "black": "STButton-module__z7DVZa__black",
  "button": "STButton-module__z7DVZa__button",
  "content": "STButton-module__z7DVZa__content",
  "disabled": "STButton-module__z7DVZa__disabled",
  "glass": "STButton-module__z7DVZa__glass",
  "icon": "STButton-module__z7DVZa__icon",
  "loader": "STButton-module__z7DVZa__loader",
  "loading": "STButton-module__z7DVZa__loading",
  "outline-black": "STButton-module__z7DVZa__outline-black",
  "outline-primary": "STButton-module__z7DVZa__outline-primary",
  "primary": "STButton-module__z7DVZa__primary",
  "spin": "STButton-module__z7DVZa__spin",
  "white": "STButton-module__z7DVZa__white",
});
